import { useParams } from "@reach/router"
import { graphql, useStaticQuery } from "gatsby"
import { useEffect } from "react"

import { marketingClient } from "@trueskin-web/apis"
import { Seo } from "@trueskin-web/components"
import { useTranslation } from "@trueskin-web/translations"

import SignupForm from "./signup-form"

const SignupContainer = ({ buttonLabel, children }) => {
  const { token } = useParams()
  const { t } = useTranslation()

  const { dialogImage } = useStaticQuery(graphql`
    {
      dialogImage: file(
        relativePath: { eq: "rebranded/rebranded-login-form.png" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 800, layout: CONSTRAINED)
        }
      }
    }
  `)

  const searchParams = new URLSearchParams(window.location.search)
  const provider = searchParams.get("provider") || ""
  const providerID = searchParams.get("providerID") || ""
  const email = searchParams.get("email") || ""

  useEffect(() => {
    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM.SIGN_UP_OPENED,
      data: {
        provider,
        temptoken: token,
      },
    })
  }, [token, provider])

  return (
    <>
      <Seo title={t("Start.CreateAccount.seoTitle")} />
      <div
        data-component-name="SignupTop"
        sx={{
          width: "100vw",
          mx: -4,
          background: "lightBlue",
        }}
      >
        {children}
      </div>

      <SignupForm
        token={token}
        provider={provider}
        providerID={providerID}
        email={email}
        buttonLabel={buttonLabel}
        dialogImage={dialogImage}
      />
    </>
  )
}

export default SignupContainer
